import React from "react";
import { useDispatch } from "react-redux";
import {
  catalogModuleCleanSearchText,
  catalogModuleSetSearchText,
  cleanSearchingCatalogModulesPaginated,
  startSearchingCatalogModulePaginated,
} from "../../app/actions/catalogModuleActions";

import { useTracking } from "react-tracking";
import { useTranslation } from "react-i18next";

const SearchBackCatalogModule = ({ searchText, setSearchText, itemsPerPage }) => {
 //console.log("SearchBackCatalogModule");
  
  const dispatch = useDispatch();
  const { trackEvent } = useTracking();
  const { t } = useTranslation();

  const onChangeInput = (event) => {
    setSearchText(event.target.value);

    if (event.target.value !== "") {
      trackEvent({ component: "SearchCatalogModules", event: "SearchCatalogModules-Clicked", search: event.target.value });

      dispatch(catalogModuleSetSearchText(event.target.value));

      dispatch(startSearchingCatalogModulePaginated(event.target.value, 0, itemsPerPage));
    } else {
      
      dispatch(cleanSearchingCatalogModulesPaginated());

      dispatch(catalogModuleCleanSearchText());
    }
  };

  return (
    <div className="row height d-flex justify-content-center align-items-center">
      <div className="col-md-8">
        <div className="search">
          <i className="fa fa-search"></i>
          <input
            type="text"
            className="form-control"
            placeholder={t("general.option_search")}
            value={searchText}
            id="searchText"
            name="searchText"
            onChange={onChangeInput}
          ></input>
        </div>
      </div>
    </div>
  );
};

export default SearchBackCatalogModule;
